<template>
  
  <div class="modal">

    <button
      @click="onClickCloseButton"
      class="button button_modal-close-button"
    ></button>
    
    <slot></slot>

  </div>

</template>

<script>
  import Utils from '@/mixins/Utils';

  export default {
    name: 'ModalWindow',

    mixins: [
      Utils,
    ],

    created() {
      this.toggleClasses(true, 'modal-open');
    },

    mounted() {
      this.$emit('open');
    },

    beforeDestroy() {
      this.toggleClasses(false, 'modal-open');
    },

    methods: {
      onClickCloseButton() {
        this.$emit('close');
      },
    },
  };
</script>


// WEBPACK FOOTER //
// src/components/ModalWindow.vue